/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react"
import Scalar from "src/libs/scalars/scalars/Scalar"
import { ICompositeWidgetProps } from "../LandingCompositeWidget"
import { ILandingStore, useLandingStore } from "../../data/store"
import { ILanding, ILandingCategory } from "../../data/interfaces"
import { ID } from "src/libs/interfaces/layouts"
import { Tag } from "@blueprintjs/core"
import { getContrastColor } from "src/libs/utilities"

/* Protopia Ecosystem component */
export interface ICategoryIdScalarProps extends ICompositeWidgetProps {
   
}
const CategoryIdScalar = (props: ICategoryIdScalarProps): JSX.Element => { 
    return <>
        <Scalar 
            subtitle={ props.subtitle }
            title={props.title }
            value={props.value}
            editable={props.editable}
            notClear
            enabledForm={<CategoryIdEnabled {...props} />}  
            desabledForm={<CategoryIdDisable {...props} />}  
            subMenus={props.subMenus}
            onSubMenu={props.onSubmenu}
            onChange={props.onChange}
        />
    </>
}
export default CategoryIdScalar

const CategoryIdEnabled = (props: ICategoryIdScalarProps): JSX.Element => {
    const currentLanding: ILanding = useLandingStore((state: ILandingStore) => state.currentLanding)
    const getCategoriesList = ( ids: ID[]): ILandingCategory[] => {
        return [...ids]
            .map(id => {
                return currentLanding.categories?.find( cat => cat.id === id)
            })
            .filter( cat => !!cat )
    }

    const [value, setValue] = useState<ILandingCategory[]>( getCategoriesList(props.value || props.default || []) )
    useEffect(() => { 
        setValue( getCategoriesList(props.value || []) )
    }, [ props.value, currentLanding.categories ])

    const onChange = (val: ILandingCategory[] ) => { 
        if(props.onChange) {
            props.onChange(
                val.map(v => v.id), 
                props.field, 
                "" 
            )
        } 
        else {
            setValue( val )
        }
    }
    const onClick = ( cat: ILandingCategory ) => {
        const is = !!value.find(v => v.id === cat.id )
        const val = is
            ?
            value.filter( v => v.id !== cat.id )
            :
            [...value, cat]
        
        onChange( val ) 
    }
    return <div className="container">
        <div className="d-flex align-items-center flex-wrap py-2">
            {
                currentLanding.categories?.map(cat => {
                    const is = !!value.find(c => c.id === cat.id)
                    return <Tag 
                        key={cat.id} 
                        style={{ 
                            backgroundColor: is ? cat.color : "grey",
                            opacity: is ? 1 : .5,
                            cursor: is ? "auto" : "pointer"
                        }} 
                        className="m-1"
                        onClick={ () => onClick( cat ) }
                    >
                        <span 
                            style={{ 
                                color: is ? getContrastColor( cat.color ) : "#FFFFFF",

                            }}
                        >
                            { cat.title }
                        </span>
                    </Tag>
                })
            }
        </div>
    </div>
}
const CategoryIdDisable = (props: ICategoryIdScalarProps): JSX.Element => {
    const [value, ] = useState<any>( props.value || props.default )
    return <div className="container">
        { JSON.stringify(value) }
    </div>
}